var Spinner = require("components/utility/Spinner");
var CurrentUser = require("lib/account/CurrentUser");
var UpgradeTokenForm = require("components/users/teachers/upgrade/UpgradeTokenForm");
var WhooosReadingServices = require("lib/web/WhooosReadingServices")

class PaymentPreferences extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false, showPaymentMethodForm: false
		};
		LuckyOrangeClient.tagComponent("PaymentPreferences");
	}
	renderHistoryRow(rowContent, key) {
		var contents = _.map(rowContent, (cellContent, index) => {
			return (
				<div className="historyCell" key={ index }>
					{ cellContent }
				</div>
			);
		});
		return (
			<div className="historyRow" key={ key }>
				{ contents }
			</div>
		);
	}
	sendReceipt(chargeData, e) {
		$wr.nope(e)

		var params = { what: "premium_account_receipt",
			stripe_payment_id: chargeData.stripe_payment_id }

		CurrentUser.api().postUserTrigger(CurrentUser.get().id, params, $wr.apiHandler((response) => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Sent!", text: "Check your inbox for your receipt.", icon: "envelope" });					
		}));

	}
	render()  {
		if (this.props.billingHistory == null) {
			return (
				<div className="billingHistory">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			)
		}

		if (this.props.billingHistory.length == 0) {
			return (
				<div className="billingHistory">
					You have no billing history.
				</div>
			);
		}

		var chargeHistoryRows = _.map(this.props.billingHistory, (chargeData, index) => {
			var receiptLink = (
				<a href="#" className="receiptLink"
					onClick={ this.sendReceipt.bind(this, chargeData) }>
					Send
				</a>
			);

			var date = $wr.formatDate(chargeData.date);

			if (chargeData.waived) {
				var chargeAmount = "Waived";
			} else {
				var chargeAmount = $wr.centsToDollars(chargeData.cents, true);
			}

			var classText = $wr.pluralizeWithNumber("class", chargeData.student_list_count, "classes");
			var planText = chargeData.plan_name + " (" + classText + ")";

			return this.renderHistoryRow([date, planText, chargeAmount, receiptLink], index);
		});

		return (
			<div className="billingHistory">
				<div className="historyHeader">
					{ this.renderHistoryRow(["Date", "Plan", "Amount", "Receipt"], "header") }
				</div>
				{ chargeHistoryRows }
			</div>
		);
	}
}
module.exports = PaymentPreferences;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/PaymentPreferences.js